module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1226.a2acf4f1.png";